export default "__VITE_ASSET__$xSDVcEF__"